module.exports = __webpack_public_path__ + "assets/img/lp-report-3.399f08cd.svg";